import { render, staticRenderFns } from "./SummaryInvestment.vue?vue&type=template&id=99b45468"
import script from "./SummaryInvestment.vue?vue&type=script&lang=js"
export * from "./SummaryInvestment.vue?vue&type=script&lang=js"
import style0 from "./SummaryInvestment.vue?vue&type=style&index=0&id=99b45468&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports